import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { MatSlider } from "@angular/material/slider";

@Component({
  selector: "app-slider-bar",
  templateUrl: "./slider-bar.component.html",
  styleUrls: ["./slider-bar.component.scss"],
})
export class SliderBarComponent {
  @ViewChild("slider") slider!: MatSlider;

  @Input() sliderValue!: any;
  @Output() sliderChangeCall = new EventEmitter<any>();

  formatLabel(value: number | null): string {
    // Always display the thumb label
    return value !== null ? value.toString() : "";
  }

  onChangeSlider(event: any) {
    const endValueIndicator =
      this.slider._elementRef.nativeElement.querySelector(
        ".mdc-slider__value-indicator-text",
      );

    if (endValueIndicator) {
      this.sliderChangeCall.emit(endValueIndicator.textContent);
      this.sliderValue = endValueIndicator.textContent;
    }
  }
}
